import { __decorate } from "tslib";
import { BaseModule, Module } from "@fastoche/core";
import { SegmentAnalyticsProvider } from "../SegmentAnalyticsProvider";
let CoreSegmentModule = class CoreSegmentModule extends BaseModule {
    registerServices(container, config) {
        container.bind(SegmentAnalyticsProvider).toSelf().inSingletonScope();
    }
    configureServices(container, config) {
        const provider = container.get(SegmentAnalyticsProvider);
        void provider.load({ writeKey: config.writeKey }, { initialPageview: config.initialPageView });
    }
};
CoreSegmentModule = __decorate([
    Module()
], CoreSegmentModule);
export { CoreSegmentModule };
//# sourceMappingURL=index.js.map